/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class UpdateResourceSecurityScansExclusionRequest {
  /**
  * True if should be excluded from security scans, false otherwise
  */
  'excluded': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "excluded",
      "baseName": "excluded",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateResourceSecurityScansExclusionRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

